/*
 * Strato Lab 3D — Quote configurator content (Italian).
 * 8-step guided request aligned to the real Strato engine.
 */

export const QUOTE_STEPS = [
  { id: "start", label: "Da cosa partiamo", micro: "PUNTO DI PARTENZA" },
  { id: "input", label: "File o riferimento", micro: "PROGETTO" },
  { id: "type", label: "Tipo di pezzo", micro: "COMPONENTE" },
  { id: "usage", label: "Uso e priorità", micro: "CONTESTO" },
  { id: "material", label: "Preferenze tecniche", micro: "FDM / PLA" },
  { id: "quantity", label: "Quantità e tempi", micro: "LOTTO" },
  { id: "notes", label: "Note finali", micro: "DETTAGLI" },
  { id: "contact", label: "Contatti e riepilogo", micro: "RICHIESTA" },
];

export const START_OPTIONS = [
  {
    id: "file",
    title: "Ho un file 3D",
    description: "Carichi STL, STEP, STP o 3MF. Lo analizziamo e lo prepariamo alla produzione.",
    hint: "STL · STEP · STP · 3MF",
  },
  {
    id: "nofile",
    title: "Non ho ancora un file",
    description: "Descrivi il pezzo: funzione, misure e riferimenti. Ti aiutiamo a capire come procedere.",
    hint: "Descrizione · Misure · Riferimenti",
  },
];

export const FILE_FORMATS = ["STL", "STEP", "STP", "3MF"];
export const FILE_MAX_LABEL = "50 MiB";

export const PIECE_TYPES = [
  "Prototipo",
  "Parte funzionale",
  "Pezzo estetico",
  "Ricambio",
  "Supporto / staffa",
  "Dima / attrezzatura",
  "Oggetto decorativo",
  "Altro",
];

export const USE_USES = [
  "Interno",
  "Esterno",
  "Meccanico / funzionale",
  "Estetico",
  "Test / prototipo",
  "Montaggio / supporto",
  "Ricambio",
  "Altro",
];

export const USE_GOALS = [
  "Contenere il costo",
  "Miglior aspetto estetico",
  "Maggiore resistenza",
  "Maggiore precisione",
  "Tempi rapidi",
  "Equilibrio generale",
];

export const MATERIAL_OPTIONS = [
  { id: "pla", label: "PLA", note: "Materiale principale" },
  { id: "advice", label: "Non so, consigliatemi voi", note: "Ti guidiamo noi" },
  { id: "custom", label: "Altro materiale su richiesta", note: "Da valutare sul progetto" },
];

export const QUOTE_MATERIAL = {
  name: "PLA",
  note: "Materiale principale · rigido e stabile",
  colors: [
    { name: "Pure White", hex: "#F5F5F5" },
    { name: "Absolute Black", hex: "#0B0D10" },
    { name: "Milky Pink", hex: "#F2D6DE" },
    { name: "Apricot", hex: "#F3C7A6" },
    { name: "Baby Blue", hex: "#BFD7EA" },
  ],
};

export const FINISH_OPTIONS = [
  "Standard",
  "Superficie più pulita possibile",
  "Layer fine",
  "Da definire in base al pezzo",
];

export const QUANTITY_PRESETS = [1, 5, 10, 25, 50];

export const URGENCY_OPTIONS = [
  "Standard",
  "Appena possibile",
  "Ho una data specifica",
  "Non urgente",
];
